export function camel (str) {
  const camel = (str || '').replace(/-([^-])/g, g => g[1].toUpperCase());

  // eslint-disable-next-line no-use-before-define
  return capitalize(camel);
}
export function capitalize (str) {
  str = str || '';

  return `${str.substr(0, 1).toUpperCase()}${str.slice(1)}`;
}

export function generateRandomPassword () {
  const charactersArray = 'a-z,A-Z,0-9,#'.split(',');
  let CharacterSet = '';
  let password = '';

  if (charactersArray.indexOf('a-z') >= 0) {
    CharacterSet += 'abcdefghijklmnopqrstuvwxyz';
  }
  if (charactersArray.indexOf('A-Z') >= 0) {
    CharacterSet += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  }
  if (charactersArray.indexOf('0-9') >= 0) {
    CharacterSet += '0123456789';
  }
  if (charactersArray.indexOf('#') >= 0) {
    CharacterSet += '![]{}()%&*$#^<>~@|';
  }

  for (let i = 0; i < 12; i++) {
    password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length));
  }
  // eslint-disable-next-line no-invalid-this
  this.password = password;
}

export function parseJwt (token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
      })
      .join(''),
  );

  return JSON.parse(jsonPayload);
}
